import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import PageContainer from '../../../shared/layout/containers/PageContainer';
import PageHeader from '../../../shared/layout/headers/PageHeader';
import PageTitle from '../../../shared/layout/titles/PageTitle';
import PageContent from '../../../shared/layout/containers/PageContent';
import MainButton from '../../../shared/layout/buttons/MainButton';
import AdminFilterBar from './components/AdminFilterBar';
import AdminDataTable from './components/AdminDataTable';
import { fetchAdminPreparedTransactions } from '../../../services/Http/AdminApi';

const AdminPreparedTransactions = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const resp = await fetchAdminPreparedTransactions({ period: '30d', per_page: 25 });
            setRows(resp?.data || []);
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Failed to load prepared transactions');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    const columns = useMemo(() => ([
        { key: 'id', label: 'ID' },
        { key: 'date_of_transaction', label: 'Date', render: (row) => row.date_of_transaction ? new Date(row.date_of_transaction).toLocaleString() : '—' },
        { key: 'transaction_type', label: 'Type' },
        { key: 'status', label: 'Status' },
        { key: 'serial_number', label: 'Serial' },
        { key: 'error_message', label: 'Error' },
    ]), []);

    return (
        <PageContainer>
            <PageHeader><PageTitle>Prepared Transactions</PageTitle></PageHeader>
            <PageContent>
                <AdminFilterBar>
                    <div>Pending/queued transaction pipeline entries</div>
                    <MainButton size="small" onClick={load}>Refresh</MainButton>
                </AdminFilterBar>
                <AdminDataTable columns={columns} rows={rows} loading={loading} emptyText="No prepared transactions" />
            </PageContent>
        </PageContainer>
    );
};

export default AdminPreparedTransactions;

